import img1 from "./assets/images/sidebar_icons/img1.png";
import img2 from "./assets/images/sidebar_icons/img2.png";
import img3 from "./assets/images/sidebar_icons/img3.png";
import img4 from "./assets/images/sidebar_icons/img4.png";
import img5 from "./assets/images/sidebar_icons/img5.png";
import img6 from "./assets/images/sidebar_icons/img6.png";
import img7 from "./assets/images/sidebar_icons/img7.png";
import img8 from "./assets/images/sidebar_icons/img8.png";
import img9 from "./assets/images/sidebar_icons/img9.png";
import img10 from "./assets/images/sidebar_icons/img10.png";
import img11 from "./assets/images/sidebar_icons/img11.png";
import img12 from "./assets/images/sidebar_icons/img12.png";
import img13 from "./assets/images/sidebar_icons/img13.png";
import img14 from "./assets/images/sidebar_icons/img14.png";
import img15 from "./assets/images/sidebar_icons/img15.png";

const _nav = [
  {
    title: "OPRATIONS",
    items: [
      { name: "Dashboard", to: "/dashboard", img: img1 },
      {
        name: "Orders",
        to: "/orders",
        img: img2,
        items: [
          { name: "Out For Delivery", to: "/orders/out-for-delivery" },
          { name: "Receive Product", to: "/orders/receive-product" },
          { name: "Delayed", to: "/orders/delayed" },
          { name: "Pending/ Hold", to: "/orders/pending" },
          { name: "Replacement", to: "/orders/replacement" },
          { name: "Repair", to: "/orders/repair" },
          { name: "Delivered Today", to: "/orders/delivered-today" },
        ],
      },
      { name: "Payments", to: "/payments", img: img3 },
      { name: "Inventory Request", to: "/inventory-request", img: img14 },
      { name: "Store All Inventory", to: "/store-all-inventory", img: img15 },
    ],
  },
  {
    title: "PEOPLE",
    items: [
      { name: "Sales Team", to: "/sales-team", img: img6 },
      { name: "New Customer", to: "/new-customer", img: img7 },
    ],
  },
  {
    title: "STORE DOCUMENT",
    items: [
      { name: "Electricity Bills", to: "/electricity-bills", img: img8 },
      // { name: "Rent Recipt", to: "/electricity-bills", img: img8 },
    ],
  },
  {
    title: "Miscellaneous",
    items: [{ name: "Store Kharch", to: "/store-kharch", img: img9 }],
  },
  {
    title: "Bill & Invoice",
    items: [{ name: "Order Billing", to: "/order-billing", img: img11 }],
  },
  {
    title: "Store Setup",
    items: [{ name: "Setup", to: "/setup", img: img10 }],
  },
  {
    title: "Raise Req to admin",
    items: [
      { name: "Raise Your Request", to: "/raise-your-request", img: img12 },
    ],
  },
  {
    title: "Communication",
    items: [{ name: "Notification", to: "/notification", img: img13 }],
  },
];

export default _nav;
